import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentUnderageAffidavitModel } from '../models/incident-underage-affidavit.model';

@Injectable()
export class UnderageIncidentService extends IncidentServiceBase<IncidentUnderageAffidavitModel> {
    constructor() {
        super('IncidentUnderageAffidavit', () => new IncidentUnderageAffidavitModel());
    }
}
